import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "filterDeals row"
};
const _hoisted_2 = { class: "col-12 border-top pt-3 pb-2" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "font6-responsive strong mb-2 d-inline-block" }, "Angebote:", -1);
const _hoisted_4 = {
    key: 1,
    class: "dummyCheckbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_checkbox_input = _resolveComponent("checkbox-input");
    const _component_v_checkbox = _resolveComponent("v-checkbox");
    return ((_a = _ctx.availableFilters) === null || _a === void 0 ? void 0 : _a.isDeal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                (_ctx.getListingType !== 'deals')
                    ? (_openBlock(), _createBlock(_component_checkbox_input, {
                        key: 0,
                        id: "Deals",
                        name: "Deals",
                        text: "Deals",
                        value: "deals",
                        modelValue: _ctx.deals,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.deals) = $event))
                    }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                (_ctx.getListingType === 'deals')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_v_checkbox, {
                            "model-value": true,
                            "true-value": true,
                            readonly: true,
                            label: "Deals",
                            color: "#4BE000",
                            value: "Deals",
                            density: "compact",
                            "hide-details": ""
                        })
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]))
        : _createCommentVNode("", true);
}
